<template>
  <div class="d-flex flex-column">
    <sf-sub-heading>{{ address.companyName }}</sf-sub-heading>
    <sf-text>{{ address.street }}</sf-text>
    <sf-text>{{ address.zipCode }} {{ address.city }}</sf-text>
    <sf-text>{{ getCountryName(address.iso3country, locale) }}</sf-text>
  </div>
</template>

<script setup lang="ts">
import SfSubHeading from '@/components/text/SfSubHeading.vue'
import SfText from '@/components/text/SfText.vue'
import { getCountryName } from '@/modules/address/helpers'
import { OrderAddress } from '@/types/index'
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  address: {
    type: Object as PropType<OrderAddress>,
    required: true
  }
})

const { locale } = useI18n()
</script>
